import { gql } from '@apollo/client';

const UPDATE_PUBLISHER_MUTATION = gql`
  mutation UpdatePublisherMutation(
    $id: Int!,
    $changed: String!
  ) {
    updatePublisher(
      id: $id,
      changed: $changed
    ) {
      message
    }
  }
`;

export default UPDATE_PUBLISHER_MUTATION;
